<template>
	<div class="flex-row flex-align-center flex-just-end">
		<div v-for="(item, index) in btnArr" :key="index" class="item pos-rela">
			<component :is="(item.type && upperCase(`${item.type}Button`)) || defaultType" :item="item" :row="row" :row-index="rowIndex"></component>
			<div class="split-line"></div>
		</div>
	</div>
</template>
<script>
import mixin from './mixin';
import Operaters from './operater';
export default {
	mixins: [mixin],
	components: {
		...Operaters,
	},
	computed: {
		btnArr() {
			const { cellValue = [] } = this;
			return cellValue;
		},
	},
	data() {
		return {
			defaultType: 'TextButton',
		};
	},
	methods: {
		click(item) {
			if (item.click) {
				item.click(this.row, this.rowIndex);
			}
		},
		upperCase(str) {
			const [first] = str;
			if (first == first.toUpperCase()) return;
			return str.replace(/^\S/, s => s.toUpperCase());
		},
	},
};
</script>
<style lang="less" scoped>
.item {
	.split-line {
		display: none;
		position: absolute;
		left: 8px;
		top: 6px;
		height: 10px;
		width: 1px;
		background-color: @color-text-placeholder;
	}
	& + & {
		padding-left: 16px;
		.split-line {
			display: block;
		}
	}
}
</style>
